import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementBlock as _createElementBlock, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "flex mb-4" }
const _hoisted_3 = { class: "flex flex-col flex-1" }
const _hoisted_4 = { class: "mb-2" }
const _hoisted_5 = { class: "flex flex-col" }
const _hoisted_6 = {
  key: 0,
  class: "flex items-center gap-2"
}
const _hoisted_7 = { class: "flex items-center" }
const _hoisted_8 = { class: "font-bold text-left text-black text-2xl" }
const _hoisted_9 = {
  key: 0,
  class: "text-start text-sm"
}
const _hoisted_10 = {
  key: 1,
  class: "text-red-500 text-xs mt-1"
}
const _hoisted_11 = {
  key: 1,
  class: "flex w-2/4 items-center gap-4"
}
const _hoisted_12 = ["onKeydown"]
const _hoisted_13 = { class: "flex gap-4" }
const _hoisted_14 = {
  key: 0,
  class: "text-sm text-left font-bold text-black my-2"
}
const _hoisted_15 = { class: "flex self-end h-[56px] mt-8 sm:mt-0" }
const _hoisted_16 = {
  key: 1,
  class: "text-red-500 text-xs mt-2"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Excluir regra da política de pagamento", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", { class: "text-base font-normal" }, [
  /*#__PURE__*/_createTextVNode(" Tem certeza que deseja excluir esta regra?"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Essa ação não poderá ser desfeita! ")
], -1)
const _hoisted_19 = { class: "flex justify-center gap-4" }

import { computed, nextTick, onMounted, ref, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { PAYMENT_TEAM_OPTIONS, useCreateScheduleStore } from '@/pinia-store/useCreateScheduleStore'
import { useToast } from 'vue-toastification'
import { useErrorToast } from '@/composables/useErrorToast'
import { useScheduleMaxDate } from '@/hooks/useScheduleMaxDate'
import Spinner from '@/components/others/Spinner.vue'
import OutlinedButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import ModalVue from '@/components/designSystem/modals/Modal.vue'

import { mdiPlus, mdiPencilOutline, mdiCheck, mdiClose } from '@mdi/js'
import PaymentPolicyRulesTable from './PaymentPolicyRulesTable.vue'
import PolicyVigencyFields from './PolicyVigencyFields.vue'
import Network from '@/Network'
import { weekDays } from '@/utils/date'


export default /*#__PURE__*/_defineComponent({
  __name: 'CreatePaymentPolicy',
  props: {
    mode: {},
    formationRequired: { type: Boolean },
    scheduleId: {},
    errors: {},
    onClearError: { type: Function }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;



const store = useCreateScheduleStore()
const { step1, step4, step2 } = storeToRefs(store)

const scheduleEndDateStr = computed(() => step1.value.endDate?.toISOString() ?? null)
const { scheduleMaxDate } = useScheduleMaxDate(scheduleEndDateStr)

const shouldShowFormation = computed(() => {
  return step2.value.formationRequired || props.formationRequired === true
})

const toast = useToast()
const { notifyError } = useErrorToast()
const loading = ref(false)
const tempPolicyName = ref('')
const isEditing = ref(props.mode === 'create')
const nameInput = ref<HTMLInputElement | null>(null)
const showModalDelete = ref(false)
const ruleIndexToDelete = ref<number | null>(null)
const isLoading = ref(false)

const repassModes = [
  { label: 'À vista', value: 'IMMEDIATE' },
  { label: 'Fluxo', value: 'FLOW' }
]

const loadOptions = async () => {
  store.setTeams(PAYMENT_TEAM_OPTIONS)
  store.setDays(weekDays)
}

const load = async () => {
  if (!props.scheduleId) return

  loading.value = true
  try {
    const data = (await Network.schedule.getById(props.scheduleId)) as any

    store.setPolicyName(data.name)
    step4.value.indefiniteEndDate = data.indefiniteEndDate ?? false
    step4.value.rules = data.rules ?? []

    tempPolicyName.value = data.name
    store.setShifts(data.shifts ?? [])
    store.setPositions(data.positions ?? [])
    store.setFormations(data.formations ?? [])
  } catch (err) {
    notifyError(err, 'Não foi possível carregar os dados da escala.')
  } finally {
    loading.value = false
  }
}

onMounted(async () => {
  await loadOptions()
  if (props.mode === 'edit') {
    await load()
  } else {
    nextTick(() => {
      nameInput.value?.focus()
    })
  }
})

watch(
  () => step4.value.name,
  (newName) => {
    if (!isEditing.value) {
      tempPolicyName.value = newName
    }
  }
)

const confirmDeleteRule = (index: number) => {
  ruleIndexToDelete.value = index
  showModalDelete.value = true
}

const handleDeletePaymentPolicy = async () => {
  if (ruleIndexToDelete.value === null) return

  isLoading.value = true
  try {
    store.removeRule(ruleIndexToDelete.value)
    toast.success('Política de plantão excluída com sucesso!')
  } catch (err) {
    toast.error('Erro ao excluir a política.')
  } finally {
    showModalDelete.value = false
    isLoading.value = false
    ruleIndexToDelete.value = null
  }
}

const copyRule = async (index: number) => {
  store.copyRule(index)
  toast.success('Regra duplicada com sucesso!')
}

const startEditing = async () => {
  tempPolicyName.value = step4.value.name
  isEditing.value = true
  await nextTick()
  nameInput.value?.focus()
}

const saveEdit = () => {
  if (!tempPolicyName.value.trim()) {
    toast.error('Nome inválido.')
    return
  }
  store.setPolicyName(tempPolicyName.value)
  isEditing.value = false
  props.onClearError?.('name')
}

const cancelEdit = () => {
  tempPolicyName.value = step4.value.name
  isEditing.value = false
}

const validateAndConfirmName = (): boolean => {
  if (!isEditing.value) return true
  if (!tempPolicyName.value.trim()) return false
  store.setPolicyName(tempPolicyName.value)
  isEditing.value = false
  props.onClearError?.('name')
  return true
}

__expose({ validateAndConfirmName })

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (loading.value)
      ? (_openBlock(), _createBlock(Spinner, {
          key: 0,
          color: 'primary',
          size: '5rem',
          width: '0.5rem',
          class: "absolute inset-0 flex justify-center items-center bg-white bg-opacity-50 z-50"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (!isEditing.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("h1", _hoisted_8, _toDisplayString(tempPolicyName.value), 1),
                      _createVNode(_component_v_icon, {
                        icon: _unref(mdiPencilOutline),
                        class: "cursor-pointer text-primary ml-1",
                        size: "20",
                        onClick: startEditing
                      }, null, 8, ["icon"])
                    ]),
                    (_ctx.mode === 'edit')
                      ? (_openBlock(), _createElementBlock("p", _hoisted_9, "Em " + _toDisplayString(_unref(step4).name), 1))
                      : _createCommentVNode("", true),
                    (_ctx.errors?.name)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.errors.name), 1))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tempPolicyName).value = $event)),
                    ref_key: "nameInput",
                    ref: nameInput,
                    class: _normalizeClass(["border rounded-md px-2 py-1 w-full", _ctx.errors?.name ? 'border-red-500' : 'border-gray-300']),
                    placeholder: "Nome da política de pagamento",
                    onKeydown: [
                      _withKeys(_withModifiers(saveEdit, ["prevent"]), ["enter"]),
                      _withKeys(_withModifiers(cancelEdit, ["prevent"]), ["esc"])
                    ],
                    onBlur: saveEdit,
                    onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onClearError?.('name')))
                  }, null, 42, _hoisted_12), [
                    [_vModelText, tempPolicyName.value]
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_v_icon, {
                      icon: _unref(mdiCheck),
                      class: "cursor-pointer text-green-600",
                      size: "30",
                      onClick: saveEdit
                    }, null, 8, ["icon"]),
                    _createVNode(_component_v_icon, {
                      icon: _unref(mdiClose),
                      class: "cursor-pointer text-red-600",
                      size: "30",
                      onClick: cancelEdit
                    }, null, 8, ["icon"])
                  ])
                ]))
          ])
        ]),
        (_ctx.mode === 'create')
          ? (_openBlock(), _createElementBlock("p", _hoisted_14, " Vigência do vínculo entre escala e política de pagamento "))
          : _createCommentVNode("", true),
        (_ctx.mode === 'create')
          ? (_openBlock(), _createBlock(PolicyVigencyFields, {
              key: 1,
              "start-date": _unref(step4).startDate,
              "onUpdate:startDate": _cache[2] || (_cache[2] = ($event: any) => ((_unref(step4).startDate) = $event)),
              "end-date": _unref(step4).endDate,
              "onUpdate:endDate": _cache[3] || (_cache[3] = ($event: any) => ((_unref(step4).endDate) = $event)),
              "indefinite-end-date": _unref(step4).indefiniteEndDate,
              "onUpdate:indefiniteEndDate": _cache[4] || (_cache[4] = ($event: any) => ((_unref(step4).indefiniteEndDate) = $event)),
              "max-date": _unref(scheduleMaxDate),
              errors: _ctx.errors,
              "testid-prefix": "create-schedule-policy-vigency",
              onClearError: _cache[5] || (_cache[5] = (f) => _ctx.onClearError?.(f))
            }, null, 8, ["start-date", "end-date", "indefinite-end-date", "max-date", "errors"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(OutlinedButton, {
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(store).addRule())),
          text: 'Adicionar regra',
          height: "32px",
          "append-icon": _unref(mdiPlus),
          class: "text-sm !w-auto !px-4 !py-1"
        }, null, 8, ["append-icon"])
      ])
    ]),
    _createVNode(PaymentPolicyRulesTable, {
      rules: _unref(step4).rules,
      shifts: _unref(step2).shifts,
      positions: _unref(step2).positions,
      teams: _unref(step2).teams,
      days: _unref(step2).days,
      formations: _unref(step2).formations,
      formationRequired: shouldShowFormation.value,
      repassModes: repassModes,
      confirmDelete: confirmDeleteRule,
      copyRule: copyRule,
      errors: _ctx.errors
    }, null, 8, ["rules", "shifts", "positions", "teams", "days", "formations", "formationRequired", "errors"]),
    (_ctx.errors?.rules)
      ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_ctx.errors.rules), 1))
      : _createCommentVNode("", true),
    _createVNode(ModalVue, {
      onClose: _cache[8] || (_cache[8] = ($event: any) => (showModalDelete.value = false)),
      modalActive: showModalDelete.value
    }, {
      header: _withCtx(() => [
        _hoisted_17
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_19, [
          _createVNode(OutlinedButton, {
            width: "119px",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (showModalDelete.value = false)),
            text: "Cancelar"
          }),
          _createVNode(FilledButton, {
            loading: isLoading.value,
            text: "Excluir",
            width: "119px",
            onClick: handleDeletePaymentPolicy
          }, null, 8, ["loading"])
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_18
      ]),
      _: 1
    }, 8, ["modalActive"])
  ]))
}
}

})